module.exports = __webpack_public_path__ + "static/media/gwen-stacy-win.82e88a12.png";